module.exports = __webpack_public_path__ + "static/media/34k.aac89e2f.webp";